import React, { Component } from "react";
import { Link, Switch, Route } from "react-router-dom";

import { post, put, del } from "../../api";
import { emit } from "../../events";

import Address from "../Address/Address";

import EditNames from "./EditNames";
import EditAddress from "./EditAddress";
import EditGeoAreas from "./EditGeoAreas";
import EditPhoneNumber from "./EditPhoneNumber";
import EditHomepage from "./EditHomepage";
import EditSearchpage from "./EditSearchpage";
import EditSearchpageLanguage from "./EditSearchpageLanguage";
import EditSitemaps from "./EditSitemaps";
import EditSeedpage from "./EditSeedpage";
import EditScrape from "./EditScrape";
import EditChainId from "./EditChainId";
import EditExclusiveIndex from "./EditExclusiveIndex";
import EditOpeningHours from "./EditOpeningHours";
import EditWebshop from "./EditWebshop";
import EditDefaultSearch from "./EditDefaultSearch";
import EditPublished from "./EditPublished";

import { PenIcon } from "../SVGIcons";

const join = arr => (arr && arr.length > 0 ? arr.join(",") : undefined);

class BasicDetails extends Component {
  closeModal = () => {
    this.props.history.goBack();
  };

  updateLBU = async data => {

    console.log('Update lbu', this.props.lbu.name, data)

    try {
      const lbu = await put("/lbus/" + this.props.lbu.id, data);
      emit("lbu_updated", lbu);
      this.closeModal();
    } catch (err) {
      alert(err.message);
    }

  };

  cloneLBU = async () => {
    try {
      const lbu = this.props.lbu;
      if (window.confirm("Make a copy of " + lbu.name + "?")) {
        console.log("clone", lbu);
        const cloned = await post("/lbus", { name: "Copy of " + lbu.name });
        console.log("Got clone", cloned);
        await put("/lbus/" + cloned.id, {
          altNames: join(lbu.altNames),
          streetName: lbu.address.streetName || "",
          streetNumber: lbu.address.streetNumber || "",
          level: lbu.address.level || "",
          postalArea: lbu.address.postalArea || "",
          postalCode: lbu.address.postalCode || "",
          geoAreas: join(lbu.geoAreas),
          phoneNumber: lbu.phoneNumber || undefined,
          homepage: lbu.homepage || undefined,
          searchpage: lbu.searchpage || undefined,
          chainId: lbu.chainId || undefined,
          searchpageLanguage: lbu.searchpageLanguage,
          exclusiveIndex: lbu.exclusiveIndex || undefined,
          openingHours: lbu.openingHours || undefined,
          lbuTypes: join(lbu.lbuTypes),
          categories: lbu.categories
            ? join(lbu.categories.map(cat => cat.id))
            : undefined,
          blockWords: join(lbu.blockWords),
          brandNames: join(lbu.brandNames),
          productNames: join(lbu.productNames),
          categoryPages: join(lbu.diffBot.categories),
          productPages: join(lbu.diffBot.products),
          brandPages: join(lbu.diffBot.brands),
          location:
            lbu.geometry && lbu.geometry.coordinates
              ? join(lbu.geometry.coordinates)
              : undefined,
          webshop: lbu.webshop,
          defaultSearch: true,
          published: false,
          sitemaps: join(lbu.sitemaps)
        });
        emit("lbu_cloned", cloned);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  deleteLBU = async () => {
    try {
      const { id, name } = this.props.lbu;
      if (window.confirm("Delete " + name + "?")) {
        await del("/lbus/" + id);
        emit("lbu_deleted", this.props.lbu);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  render() {
    const {
      id,
      name = "",
      altNames = [],
      geoAreas = [],
      address = {},
      geometry = {},
      phoneNumber = "",
      homepage = "",
      searchpage = "",
      searchpageLanguage = 0,
      sitemaps = [],
      seedpage = "",
      scrapepage = "",      
      chainId = "",
      exclusiveIndex = 5,
      openingHours = "",
      webshop = 0,
      defaultSearch = true,
      published = false,
      crawler = {},
      scraper = {}
    } = this.props.lbu;

    const location = geometry.coordinates || [0, 0];

    return (
      <div className="BasicDetails">

        <div className="id">
          {id}
        </div>

        <h2>
          Name / Alt. Name
          <Link to={`/lbus/${id}/basic/edit_names`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="name">{name}</div>
        {altNames && altNames.length > 0 && (
          <ul className="altNames">
            {altNames.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
        )}

        <h2>
          Address
          <Link to={`/lbus/${id}/basic/edit_address`}>
            <PenIcon />
          </Link>
        </h2>
        <div>
          <Address address={address} />
        </div>

        <h2>
          Geo areas
          <Link to={`/lbus/${id}/basic/edit_geo_areas`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{geoAreas.join(" · ")}</div>

        <h2>
          Phone number
          <Link to={`/lbus/${id}/basic/edit_phone_number`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{phoneNumber}</div>

        <h2>
          Homepage URL
          <Link to={`/lbus/${id}/basic/edit_homepage`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          <a href={homepage} target="_blank">
            {homepage}
          </a>
        </div>

        <h2>
          Searchpage URL
          <Link to={`/lbus/${id}/basic/edit_searchpage`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          <a href={searchpage} target="_blank">
            {searchpage}
          </a>
        </div>

        <h2>
          Searchpage Language
          <Link to={`/lbus/${id}/basic/edit_searchpage_language`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="searchpageLanguage">
          {["Sv", "En", "Fr"][searchpageLanguage]}
        </div>

        <h2>
          Sitemap URLs
          <Link to={`/lbus/${id}/basic/edit_sitemaps`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          {sitemaps.map((sitemap, index) => {
            return (
              <div key={index}>
                <a href={sitemap} target="_blank">
                  {sitemap}
                </a>
              </div>
            );
          })}
        </div>

        <h2>
          Seedpage URL for crawling
          {(crawler && crawler.date) && (
            <div className="crawlInfo">
                Crawled {crawler.date.substring(0,16).replace("T", " ")} Links: {crawler.urls}
            </div>
          )}
          <Link to={`/lbus/${id}/basic/edit_seedpage`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          <a href={seedpage} target="_blank">
            {seedpage}
          </a>
        </div>

        <h2>
          {(scraper && scraper.date) ? (
            <div className="url">
              Scraped {scraper.date.substring(0,16).replace("T", " ")} Links: {scraper.scraped}
            </div>
          ) : (
            <div className="url">
              Not scraped.
            </div>
          )}
          {(scraper || crawler || sitemaps.length > 0) && (
            <Link to={`/lbus/${id}/basic/edit_scrape`}>
              <PenIcon />
            </Link>    
          )} 
        </h2>


        <h2>
          Chain ID
          <Link to={`/lbus/${id}/basic/edit_chain_id`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          <a href={chainId} target="_blank">
            {chainId}
          </a>
        </div>

        <h2>
          Exclusive Index
          <Link to={`/lbus/${id}/basic/edit_exclusive_index`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="number">
          <a href={exclusiveIndex} target="_blank">
            {exclusiveIndex}
          </a>
        </div>

        <h2>
          Opening hours URL
          <Link to={`/lbus/${id}/basic/edit_opening_hours`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="url">
          <a href={openingHours} target="_blank">
            {openingHours}
          </a>
        </div>

        <h2>
          Webshop
          <Link to={`/lbus/${id}/basic/edit_webshop`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="webshop">
          {["No webshop", "Webshop and store", "Only webshop"][webshop]}
        </div>

        <h2>
          Include in default Search
          <Link to={`/lbus/${id}/basic/edit_default_search`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="defaultSearch">{defaultSearch ? "Yes" : "No"}</div>

        <h2>
          Published
          <Link to={`/lbus/${id}/basic/edit_published`}>
            <PenIcon />
          </Link>
        </h2>
        <div className="published">{published ? "Yes" : "No"}</div>

        <h2>Clone and delete</h2>
        <div>
          <button type="button" onClick={this.cloneLBU}>
            Clone LBU
          </button>
          &nbsp;
          <button type="button" onClick={this.deleteLBU}>
            Delete LBU
          </button>
        </div>

        <Switch>
          <Route
            path="/lbus/:id/basic/edit_names"
            render={() => (
              <EditNames
                name={name}
                altNames={altNames}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_address"
            render={() => (
              <EditAddress
                {...address}
                location={location}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_geo_areas"
            render={() => (
              <EditGeoAreas
                geoAreas={geoAreas}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_phone_number"
            render={() => (
              <EditPhoneNumber
                phoneNumber={phoneNumber}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_homepage"
            render={() => (
              <EditHomepage
                homepage={homepage}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_searchpage"
            render={() => (
              <EditSearchpage
                searchpage={searchpage}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_searchpage_language"
            render={() => (
              <EditSearchpageLanguage
                searchpageLanguage={searchpageLanguage}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_sitemaps"
            render={() => (
              <EditSitemaps
                sitemaps={sitemaps}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_seedpage"
            render={() => (
              <EditSeedpage
                seedpage={seedpage}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_scrape"
            render={() => (
              <EditScrape
                scrapepage={scrapepage}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />          
          <Route
            path="/lbus/:id/basic/edit_chain_id"
            render={() => (
              <EditChainId
                chainId={chainId}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />          
          <Route
            path="/lbus/:id/basic/edit_exclusive_index"
            render={() => (
              <EditExclusiveIndex
                exclusiveIndex={exclusiveIndex}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_opening_hours"
            render={() => (
              <EditOpeningHours
                openingHours={openingHours}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_webshop"
            render={() => (
              <EditWebshop
                webshop={webshop}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_default_search"
            render={() => (
              <EditDefaultSearch
                defaultSearch={defaultSearch}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/basic/edit_published"
            render={() => (
              <EditPublished
                published={published}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default BasicDetails;



// WEBPACK FOOTER //
// ./src/components/LBUs/BasicDetails.js